<p-card [style]="{'position': 'relative'}">
    <div class="grid">
        <div class="col-12">
            <div class="flex align-items-center justify-content-between mb-2">
                <div class="flex align-items-center gap-3">
                    <p-multiSelect [options]="emplacements" [(ngModel)]="selectedEmplacements"
                        optionLabel="code" placeholder="Sélectionner les emplacements..."
                        [style]="{'minWidth': '250px'}" (onChange)="onEmplacementChange()" [filter]="true" filterBy="code,nom">
                        <ng-template let-emplacement pTemplate="item">
                            <div>{{emplacement.code}} - {{emplacement.nom}}</div>
                        </ng-template>
                    </p-multiSelect>
                    <button pButton pRipple icon="pi pi-plus" label="Ajouter"
                            class="p-button-success"
                            (click)="nouveauRapportSST()"></button>
                </div>
            </div>

            <p-calendar [(ngModel)]="currentDate" [inline]="true" [showWeek]="true"
                [monthNavigator]="true" [yearNavigator]="false" 
                (onSelect)="onDateSelect($event)" (onMonthChange)="onMonthChange($event)"
                [style]="{'width': '100%'}">
                <ng-template pTemplate="date" let-date>
                    <div class="calendar-date-cell" [class.has-reports]="getDayReports(date).length > 0">
                        <span style="max-height: 15px;">{{getDay(date)}}</span>
                        <div class="reports-container" *ngIf="getDayReports(date).length > 0">
                            <div *ngFor="let report of getDayReports(date)" class="report-item" (click)="onReportClick(report)">
                                <div class="report-header">
                                    <i class="pi pi-file"></i>
                                    <span class="report-code">{{report.emplacement.code}}</span>
                                    <span [class]="'status-badge ' + report.statut.nom.toLowerCase()">{{report.statut.nom}}</span>
                                </div>
                                <div class="report-details">
                                    <i class="pi pi-user"></i>
                                    <span class="report-employee">{{report.employe.prenom}} {{report.employe.nom}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-calendar>
        </div>
    </div>
    <p-progressSpinner *ngIf="loading" [style]="{'position': 'absolute', 'top': '50%', 'left': '50%', 'transform': 'translate(-50%, -50%)'}"></p-progressSpinner>
</p-card>

<style>
    :host ::ng-deep {
        .calendar-date-cell {
            min-height: 80px;
            padding: 4px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            height: 100%;
        }

        .reports-container {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .p-datepicker table td > span {
            border-radius: 0px !important;
            border: 1px solid var(--surface-border);
        }

        .report-item {
            font-size: 0.85rem;
            padding: 4px 6px;
            background-color: var(--surface-card);
            color: var(--text-color);
            border: 1px solid var(--surface-border);
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            gap: 4px;
            cursor: pointer;
            transition: all 0.2s;
        }

        .report-item:hover {
            background-color: var(--surface-hover);
            transform: translateY(-1px);
        }

        .report-header {
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .report-details {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 0.8rem;
            color: var(--text-color-secondary);
        }

        .report-code {
            font-weight: 600;
        }

        .status-badge {
            font-size: 0.7rem;
            padding: 2px 6px;
            border-radius: 12px;
            margin-left: auto;
        }

        .status-badge.brouillon {
            background-color: var(--yellow-100);
            color: var(--yellow-900);
        }

        .status-badge.soumis {
            background-color: var(--blue-100);
            color: var(--blue-900);
        }

        .status-badge.approuve {
            background-color: var(--green-100);
            color: var(--green-900);
        }

        .status-badge.rejete {
            background-color: var(--red-100);
            color: var(--red-900);
        }

        .has-reports {
            background-color: var(--surface-hover);
            border-radius: 5px;
        }

        .p-datepicker {
            width: 100%;
            min-height: 400px;
        }

        .p-datepicker table td {
            padding: 0;
        }

        .p-datepicker table td > span {
            width: 100%;
            height: 100%;
        }

        .p-datepicker-calendar-container {
            height: 100%;
        }

        .p-datepicker-calendar {
            table-layout: fixed;
        }

        .p-datepicker table {
            height: 100%;
        }
    }
</style> 